import React from 'react'
import { useSearchParams } from 'react-router-dom'

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from '@azure/msal-react'

import { TenantConfig } from '../../../data/models'
import { TenantContainer } from '../../../utils/tenants'
import {
  setCurrentTenantConfig,
  useCurrentTenantConfig,
} from '../../../utils/tenants'
import { AuthenticatedLayout } from '../AuthenticatedLayout'
import { ThemeLoaderLayout } from '../ThemeLoaderLayout'
import { UnauthenticatedLayout } from '../UnauthenticatedLayout'

export const RootLayout: React.FC = () => {
  const tenantConfig = useCurrentTenantConfig()
  const [searchParams] = useSearchParams()

  const tenantIdFromQuery = searchParams.get('tid')
  const projectIdFromQuery = searchParams.get('pid')

  if (tenantIdFromQuery && projectIdFromQuery) {
    if (
      tenantIdFromQuery !== tenantConfig?.tenantId ||
      projectIdFromQuery !== tenantConfig.projectId
    ) {
      const newTenantConfig: TenantConfig = {
        projectId: projectIdFromQuery,
        tenantId: tenantIdFromQuery,
      }

      setCurrentTenantConfig(newTenantConfig)
    }
  }

  return (
    <>
      <AuthenticatedTemplate>
        <TenantContainer>
          <ThemeLoaderLayout>
            <AuthenticatedLayout />
          </ThemeLoaderLayout>
        </TenantContainer>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <UnauthenticatedLayout />
      </UnauthenticatedTemplate>
    </>
  )
}
